// OWNLIVE1 (P0.31): every billing screen says, in words, which Stripe mode its numbers come from. Test mode never charges
// anyone; live mode moves real money. One place so the words never differ between screens.

/** `live_unswitched`: a live server holds this customer's Stripe customer, but it is not switched to live billing yet. */
export type BillingModeName = "test" | "live" | "live_unswitched";

export function isBillingMode(value: unknown): value is BillingModeName {
  return value === "test" || value === "live" || value === "live_unswitched";
}

/** The sentence a billing screen shows for a mode. */
export function billingModeWords(mode: BillingModeName): string {
  if (mode === "live_unswitched") {
    return "Stripe customer created, not billing yet: nothing is charged until Snip & Sip switches this customer to live.";
  }
  return mode === "live" ? "Live mode: real money is charged." : "Test mode: no real money is charged.";
}

/** Writes the sentence into a line element and shows it; hides the line when the mode is unknown (never guesses). */
export function showBillingMode(line: HTMLElement, mode: unknown): void {
  if (isBillingMode(mode)) {
    line.textContent = billingModeWords(mode);
    line.dataset["mode"] = mode;
    line.hidden = false;
  } else {
    line.textContent = "";
    delete line.dataset["mode"];
    line.hidden = true;
  }
}
